// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7446e4a","475":"b5d0dfa4"}[chunkId] + ".chunk.js";
};